/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Delivery_Vehicle_TitleInputs */

const vi_order_delivery_vehicle_title = /** @type {(inputs: Order_Delivery_Vehicle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xe giao hàng`)
};

/**

* @param {Order_Delivery_Vehicle_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_delivery_vehicle_title = /** @type {((inputs?: Order_Delivery_Vehicle_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Delivery_Vehicle_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_delivery_vehicle_title(inputs)
});